export enum ApplePayGatewayType {
    BRAINTREE = 'braintree',
    BRAINTREE_FASTLANE = 'braintreeacceleratedcheckout',
}
